import { CommonFunctions } from '../static/common-functions';
//import { Console } from '@angular/core/src/console';
import { v_DispatchAttachmentBus } from './v_DispatchAttachmentBus';
import { v_DispatchAttachmentDetailBus } from './v_DispatchAttachmentDetailBus';
import { v_DispatchAssignmentBus } from './v_DispatchAssignmentBus';
import { v_DispatchLaborBus } from './v_DispatchLaborBus';
import { v_DispatchStatusHistoryBus } from './v_DispatchStatusHistoryBus';
import { v_DispatchEquipmentSvcdBus } from './v_DispatchEquipmentSvcdBus';
import { v_DispatchPartBus } from './v_DispatchPartBus';
import { v_DispatchBus } from './v_DispatchBus';
import { DispatchesService } from '../services/dispatches.service';
import { Subscription } from 'rxjs';
import { DispatchBus } from './DispatchBus';
import { v_DispatchPartsRequestedBus } from './v_DispatchPartsRequestedBus';
import { v_DispatchPartsOrderedBus } from './v_DispatchPartsOrderedBus';
import { BasePage } from './BasePage';
import { DispatchCustPartsBus } from './DispatchCustPartsBus';
import { DQOIErrorBus } from './DQOIError';
import { DispatchVendorCreditBus } from './DispatchVendorCreditBus';
import { DispatchAssetBus } from './DispatchAssetBus';
import { v_DispatchNoteBus } from './v_DispatchNoteBus';
import { BaseMessageInfo } from './BaseMessageInfo';
import { DispatchKudosBus } from './DispatchKudosBus';
import { DispatchLaborBus } from './DispatchLaborBus';
import { InventoryQVBus } from './InventoryQVBus';
import { KudosAndOpportunityBus } from './KudosAndOpportunityBus';
import { AssignTechDispatchBus } from './AssignTechDispatchBus';
import { GItem } from './GItem';
import { CommonParam } from './CommonParam';
import { DQOIReferenceData } from './DQOIReferenceData';
import { FeatureFlagService } from '../services/feature-flag.service';

export class DispatchPage extends BasePage<DispatchesService>
{
  svc_data: DispatchesService;
  private featureFlagSet: any = {};
  private featureSubscription: Subscription;
  constructor(svc_data: DispatchesService, data: DispatchPage = null,
    public featureFlagService: FeatureFlagService = null
  )
  {
      super();
    this.svc_data = svc_data;
    if (data !== null) {
      this.dispatchId = data.dispatchId;
      this.dispatch = data.dispatch;
      this.dispatchAttachments = data.dispatchAttachments;
      this.images = data.images;
      this.assignments = data.assignments;
      this.labor = data.labor;
      this.statusHistory = data.statusHistory;
      this.equipment = data.equipment;
      this.parts = data.parts;
      this.partsRequested = data.partsRequested;
      this.partsOrdered = data.partsOrdered;
      this.history = data.history;
        this.partsQV = data.partsQV;
        this.kudosAndOpportunities = data.kudosAndOpportunities;
  //    this.invoices = data.invoices;
    }

      if (this.featureFlagService) {
          this.featureSubscription = this.featureFlagService.featureFlagSets.subscribe(data => {
              this.featureFlagSet = data;
          });
      }
  }

 clear() {
     this.unsubscribe();
     this.dispatchId = null;
     this.dispatch = null;
     this.dispatchAttachments = null;
     this.images = null;
     this.history = null;
     this.assignments = null;
     this.labor = null;
     this.parts = null;
     this.custParts = null;
     this.partsRequested = null;
     this.partsOrdered = null;
     this.equipment = null;
     this.statusHistory = null;
     this.dispatchNotes = null;
     this.dispatchKudos = null;
     this.laborQV = null;
     this.partsQV = null;
     this.errors = null;
     this.dispatchAttachmentsLoading = false;
     this.imagesLoading = false;
     this.historyLoading = false;
     this.assignmentsLoading = false;
     this.laborLoading = false;
     this.partsLoading = false;
     this.custPartsLoading = false;
     this.partsRequestedLoading = false;
     this.partsOrderedLoading = false;
     this.equipmentLoading = false;
     this.statusHistoryLoading = false;
     this.errorsLoading = false;
     this.vendorCreditsLoading = false;
     this.assetsLoading = false;
     this.dispatchNotesLoading = false;
     this.dispatchKudosLoading = false;
     this.laborQVLoading = false;
     this.kudosAndOpportunitiesLoading = false;
//     this.quotes = null;
//     this.invoices = null;
 }
  unsubscribe() {
    CommonFunctions.unsubscribe(this.subs_attachments);
    CommonFunctions.unsubscribe(this.subs_images);
    CommonFunctions.unsubscribe(this.subs_history);
    CommonFunctions.unsubscribe(this.subs_assignments);
    CommonFunctions.unsubscribe(this.subs_labor);
    CommonFunctions.unsubscribe(this.subs_parts);
    CommonFunctions.unsubscribe(this.subs_custParts);
    CommonFunctions.unsubscribe(this.subs_partsReq);
    CommonFunctions.unsubscribe(this.subs_partsOrd);
    CommonFunctions.unsubscribe(this.subs_equipSvcd);
    CommonFunctions.unsubscribe(this.subs_statusHist);
      CommonFunctions.unsubscribe(this.subs_custParts);
      CommonFunctions.unsubscribe(this.subs_errors);
      CommonFunctions.unsubscribe(this.subs_vendorCredits);
      CommonFunctions.unsubscribe(this.subs_assets);
      CommonFunctions.unsubscribe(this.subs_dispatchNotes);
      CommonFunctions.unsubscribe(this.subs_dispatchKudos);
      CommonFunctions.unsubscribe(this.subs_laborQV);
      CommonFunctions.unsubscribe(this.subs_partsQV);
      CommonFunctions.unsubscribe(this.subs_kudosAndOpportunities);
      CommonFunctions.unsubscribe(this.subs_dispatchTrucks);

  }

    subs_attachments: Subscription;
    subs_images: Subscription;
    subs_history: Subscription;
    subs_assignments: Subscription;
    subs_labor: Subscription;
    subs_parts: Subscription;
    subs_partsReq: Subscription;
    subs_partsOrd: Subscription;
    subs_custParts: Subscription;
    subs_equipSvcd: Subscription;
    subs_statusHist: Subscription;
    subs_errors: Subscription;
    subs_vendorCredits: Subscription;
    subs_assets: Subscription;
    subs_dispatchNotes: Subscription;
    subs_dispatchKudos: Subscription;
    subs_laborQV: Subscription;
    subs_partsQV: Subscription;
    subs_kudosAndOpportunities: Subscription;
    subs_dispatchTrucks: Subscription;

    setPartsRequested(data: v_DispatchPartsRequestedBus[]) {
        let arr = [];
        if (CommonFunctions.hasArrayValue(data)) {
            let arr: v_DispatchPartsRequestedBus[] = [];
            for (let i = 0; i < data.length; i++) {
                arr.push(new v_DispatchPartsRequestedBus(data[i]));
            }
            this.partsRequested = arr;
        }
    }

    getDispatchAttachments(id: any, includeSystemGenerated: boolean = true) {
        if (CommonFunctions.hasGuidValue(id)) {
            CommonFunctions.unsubscribe(this.subs_attachments);
            this.dispatchAttachmentsLoading = true;
            if (this.featureFlagSet[`construction-job-attachments`]) {
                this.subs_attachments = this.svc_data.GetDocs(id, includeSystemGenerated).subscribe(data => {
                    let arr = [];
                    if (CommonFunctions.hasArrayValue(data)) {
                        for (let i = 0; i < data.length; i++) {
                            let newObj: v_DispatchAttachmentBus = new v_DispatchAttachmentBus(data[i]);
                            arr.push(newObj);
                        }
                    }
                    this.dispatchAttachmentsLoading = false;
                    this.dispatchAttachments = arr;
                });
            } else {
                this.subs_attachments = this.svc_data.GetDocs(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: v_DispatchAttachmentBus = new v_DispatchAttachmentBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchAttachmentsLoading = false;
                this.dispatchAttachments = arr;
            });
            }

        }
        else {
            this.dispatchAttachments = [];
        }
    }
    getImages(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.imagesLoading = true;
            CommonFunctions.unsubscribe(this.subs_images);
            this.subs_images = this.svc_data.GetImages(id).subscribe(data => {
                this.images = data;
                this.imagesLoading = false;
            });
        }
        else {
            this.images = [];
        }
    }
    getPartsQV(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.partsQVLoading = true;
            CommonFunctions.unsubscribe(this.subs_partsQV);
            this.subs_partsQV = this.svc_data.GetInventoryQVs(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: InventoryQVBus = new InventoryQVBus(data[i]);
                        arr.push(newObj);
                    }
                }

                this.partsQV = arr;
                this.partsQVLoading = false;
            });
        }
        else {
            this.partsQV = [];
        }
    }

    getHistory(id: any, startDate: Date = null) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.historyLoading = true;
            CommonFunctions.unsubscribe(this.subs_history);
            let param: CommonParam = new CommonParam();
            param.addParam("StartDate", startDate);
            this.subs_history = this.svc_data.GetHistory(id, param).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: v_DispatchBus = new v_DispatchBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.history = arr;
                this.historyLoading = false;
            });
        }
        else {
            this.history = [];
        }
    }

    getAssignments(id: any, referenceData: DQOIReferenceData) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.assignmentsLoading = true;
            CommonFunctions.unsubscribe(this.subs_assignments);
            this.subs_assignments = this.svc_data.GetDispatchAssignments(id).subscribe(data => {
                let arr: v_DispatchAssignmentBus[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        var newObject = new v_DispatchAssignmentBus(data[i])
                        newObject.assignedPersonName = referenceData.getPerson(newObject.assignedPersonId);
                        newObject.assignedByPersonName = referenceData.getPerson(newObject.assignedByPersonId);
                        arr.push(newObject);
                    }
                }
                this.assignments = arr;
                this.assignmentsCurrent = this.getAssignmentsCurrent();
                this.assignmentsLoading = false;
            });
        }
        else {
            this.assignments = [];
            this.assignmentsCurrent = [];
        }
    }
    getLabor(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.laborLoading = true;
            CommonFunctions.unsubscribe(this.subs_labor);
            this.subs_labor = this.svc_data.GetDispatchLabor(id).subscribe(data => {
                let arr: v_DispatchLaborBus[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        arr.push(new v_DispatchLaborBus(data[i]));
                    }
                }
                this.labor = arr;

                this.laborLoading = false;
            });
        }
        else {
            this.labor = [];
        }
    }
    getParts(id: any, referenceData: DQOIReferenceData) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.partsLoading = true;
            CommonFunctions.unsubscribe(this.subs_parts);
            this.subs_parts = this.svc_data.GetDispatchParts(id).subscribe(data => {
                let arr: v_DispatchPartBus[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        var newObject = new v_DispatchPartBus(data[i])
                        newObject.warehouse = referenceData.getWarehouse(newObject.inventoryLocationId);
                        arr.push(newObject );
                    }
                }
                this.parts = arr;
                this.partsLoading = false;
            });
        }
        else {
            this.parts = [];
        }
    }
    getPartsRequested(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.partsRequestedLoading = true;
            CommonFunctions.unsubscribe(this.subs_partsReq);
            this.subs_partsReq = this.svc_data.GetDispatchPartsRequested(id).subscribe(data => {
                let arr: v_DispatchPartsRequestedBus[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        arr.push(new v_DispatchPartsRequestedBus(data[i]));
                    }
                }
                this.partsRequested = arr;
                this.partsRequestedLoading = false;
            });
        }
        else {
            this.partsRequested = [];
        }
    }
    getPartsOrdered(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.partsOrderedLoading = true;
            CommonFunctions.unsubscribe(this.subs_partsOrd);
            this.subs_partsOrd = this.svc_data.GetDispatchPartsOrdered(id).subscribe(data => {
                let arr: v_DispatchPartsOrderedBus[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        arr.push(new v_DispatchPartsOrderedBus(data[i]));
                    }
                }
                this.partsOrdered = arr;

                this.partsOrderedLoading = false;
            });
        }
        else {
            this.partsOrdered = [];
        }
    }
    getPartsOrderedAll(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.partsOrderedLoading = true;
            CommonFunctions.unsubscribe(this.subs_partsOrd);
            this.subs_partsOrd = this.svc_data.getDispatchPartsOrderedAll(id).subscribe(data => {
                let arr: v_DispatchPartsOrderedBus[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        arr.push(new v_DispatchPartsOrderedBus(data[i]));
                    }
                }
                this.partsOrdered = arr;

                this.partsOrderedLoading = false;
            });
        }
        else {
            this.partsOrdered = [];
        }
    }
    getCustParts(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.custPartsLoading = true;
            CommonFunctions.unsubscribe(this.subs_custParts);
            this.subs_parts = this.svc_data.getDispatchCustParts(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newDataObj: DispatchCustPartsBus = new DispatchCustPartsBus(data[i]);
                        arr.push(newDataObj);
                    }
                }
                this.custParts = arr;
                this.custPartsLoading = false;
            });
        }
        else {
            this.custParts = [];
        }
    }
    getEquipmentSvcd(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.equipmentLoading = true;
            CommonFunctions.unsubscribe(this.subs_equipSvcd);
            this.subs_equipSvcd = this.svc_data.GetDispatchEquipment(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newDataObj: v_DispatchEquipmentSvcdBus = new v_DispatchEquipmentSvcdBus(data[i]);
                        arr.push(newDataObj);
                    }
                }
                this.equipment = arr;
                this.equipmentLoading = false;
            });
        }
        else {
            this.equipment = [];
        }
    }
    getEquipmentSvcdOnly(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.equipmentLoading = true;
            CommonFunctions.unsubscribe(this.subs_equipSvcd);
            this.subs_equipSvcd = this.svc_data.GetDispatchEquipmentServiced(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newDataObj: v_DispatchEquipmentSvcdBus = new v_DispatchEquipmentSvcdBus(data[i]);
                        arr.push(newDataObj);
                    }
                }
                this.equipment = arr;
                this.equipmentLoading = false;
            });
        }
        else {
            this.equipment = [];
        }
    }
    getStatusHistory(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.statusHistoryLoading = true;
            CommonFunctions.unsubscribe(this.subs_statusHist);
            this.subs_statusHist = this.svc_data.GetDispatchStatusHistory(id).subscribe(data => {
                this.statusHistory = data;
                this.statusHistoryLoading = false;
            });
        }
        else {
            this.statusHistory = [];
        }
    }
    getErrors(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.errorsLoading = true;
            CommonFunctions.unsubscribe(this.subs_errors);
            this.subs_errors = this.svc_data.getErrors(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: DQOIErrorBus = new DQOIErrorBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.errors = arr;
                this.errorsLoading = false;
            });
        }
        else {
            this.errors = [];
        }
    }
    getVendorCredits(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.vendorCreditsLoading = true;
            CommonFunctions.unsubscribe(this.subs_vendorCredits);
            this.subs_vendorCredits = this.svc_data.getVendorCredits(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: DispatchVendorCreditBus = new DispatchVendorCreditBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.vendorCredits = arr;
                this.vendorCreditsLoading = false;
            });
        }
        else {
            this.vendorCredits = [];
        }
    }
    getAssets(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.assetsLoading = true;
            CommonFunctions.unsubscribe(this.subs_assets);
            this.subs_assets = this.svc_data.getAssets(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: DispatchAssetBus = new DispatchAssetBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.assets = arr;
                this.assetsLoading = false;
            });
        }
        else {
            this.assets = [];
        }
    }
    getDispatchNotes(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchNotesLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchNotes);
            this.subs_dispatchNotes = this.svc_data.getDispatchNotes(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (!info.saveError && CommonFunctions.hasArrayValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: v_DispatchNoteBus = new v_DispatchNoteBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchNotes = arr;
                this.dispatchNotesLoading = false;
            });
        }
        else {
            this.dispatchNotes = [];
        }
    }

    getKudosAndOpportunities(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.kudosAndOpportunitiesLoading = true;
            CommonFunctions.unsubscribe(this.subs_kudosAndOpportunities);
            this.subs_kudosAndOpportunities = this.svc_data.getKudosAndOpportunities(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (!info.saveError && CommonFunctions.hasArrayValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: KudosAndOpportunityBus = new KudosAndOpportunityBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.kudosAndOpportunities = arr;
                this.kudosAndOpportunitiesLoading = false;
                console.log("disppage->getKudosAndOpportunities: ", arr, info);
            });
        }
        else {
            this.kudosAndOpportunities = [];
        }
    }
    getDispatchKudos(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchKudosLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchKudos);
            this.subs_dispatchNotes = this.svc_data.getDispatchKudos(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (!info.saveError && CommonFunctions.hasArrayValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: DispatchKudosBus = new DispatchKudosBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchKudos = arr;
                this.dispatchKudosLoading = false;
            });
        }
        else {
            this.dispatchKudos = [];
        }
    }

    getDispatchTrucks(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchId = id;
            this.dispatchKudosLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchTrucks);
            this.subs_dispatchTrucks = this.svc_data.getDispatchTrucks(id).subscribe((info:GItem[]) => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(info)) {
                    for (let i = 0; i < info.length; i++) {
                        let newObj: GItem = new GItem(info[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchTrucks = arr;
                this.dispatchTrucksLoading = false;
            });
        }
        else {
            this.dispatchTrucks = [];
        }
    }

    getLaborQV(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.laborQVLoading = true;
            CommonFunctions.unsubscribe(this.subs_laborQV);
            this.subs_laborQV = this.svc_data.getDispatchLaborQV(id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let arr: DispatchLaborBus[] = [];
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        arr.push(new DispatchLaborBus(info.primaryReturn[i]));
                    }
                    this.laborQV = arr;
                }

                this.laborQVLoading = false;
            });
        }
        else {
            this.laborQV = [];
        }
    }
  dispatchId: any;
  dispatch: DispatchBus;
  dispatchAttachments: v_DispatchAttachmentBus[];
  images: v_DispatchAttachmentDetailBus[];
  assignments: v_DispatchAssignmentBus[];
    assignmentsCurrent: v_DispatchAssignmentBus[];
  labor: v_DispatchLaborBus[];
  statusHistory: v_DispatchStatusHistoryBus[];
  equipment: v_DispatchEquipmentSvcdBus[];
  parts: v_DispatchPartBus[];
  partsRequested: v_DispatchPartsRequestedBus[];
  partsOrdered: v_DispatchPartsOrderedBus[];
    history: v_DispatchBus[];
    dispatchTrucks: GItem[]
    partsQV:InventoryQVBus[];
  errors: DQOIErrorBus[];
//  quotes: v_QuoteBus[];
//  invoices: v_InvoiceBus[];
    custParts: DispatchCustPartsBus[];
    vendorCredits: DispatchVendorCreditBus[];
    assets: DispatchAssetBus[];
    dispatchNotes: v_DispatchNoteBus[];
    dispatchKudos: DispatchKudosBus[];
    laborQV: DispatchLaborBus[];
    kudosAndOpportunities: KudosAndOpportunityBus[];

    dispatchAttachmentsLoading: boolean = false;
    imagesLoading: boolean = false;
    assignmentsLoading: boolean = false;
    laborLoading: boolean = false;
    statusHistoryLoading: boolean = false;
    equipmentLoading: boolean = false;
    partsLoading: boolean = false;
    partsRequestedLoading: boolean = false;
    partsOrderedLoading: boolean = false;
    historyLoading: boolean = false;
    errorsLoading: boolean = false;
    custPartsLoading: boolean = false;
    vendorCreditsLoading: boolean = false;
    assetsLoading: boolean = false;
    dispatchNotesLoading: boolean = false;
    dispatchKudosLoading: boolean = false;
    laborQVLoading: boolean = false;
    partsQVLoading: boolean = false;
    kudosAndOpportunitiesLoading: boolean = false;
    dispatchTrucksLoading: boolean = false;

    get assignmentsHistory(): v_DispatchAssignmentBus[] {
        let arr: v_DispatchAssignmentBus[] = [];
        if(this.assignments && this.hasAssignments)
        {
            arr = this.assignments.filter(s => s.isCurrent === false);
        }
        return arr;
    }
  getAssignmentsCurrent() : v_DispatchAssignmentBus[] {
        let arr: v_DispatchAssignmentBus[] = [];
        if(this.assignments && this.hasAssignments)
        {
            arr = this.assignments.filter(s => s.isCurrent === true);
        }
        return arr;
    }
    get notesNonInjury(): v_DispatchNoteBus[] {
        return CommonFunctions.hasArrayElementValue(this.dispatchNotes) ? this.dispatchNotes.filter(s => s.isWarning === false) : [];
    }
  get hasAttachments(): boolean {
    return CommonFunctions.hasValue(this.dispatchAttachments) || this.dispatchAttachmentsLoading;
  }
  get hasAttachments_Refrigerant(): boolean {
      let hasRef: boolean = false;
      if (this.hasAttachments) {
          let refObjs = this.dispatchAttachments.filter(s => s.isRefrigerant == true);
          hasRef = CommonFunctions.hasArrayElementValue(refObjs);
          console.log("hasAttachments_Refrigerant: ",hasRef, refObjs);
      }
      return hasRef;
  }
  get hasImages(): boolean {
    return CommonFunctions.hasValue(this.images) || this.imagesLoading;
  }
  get hasHistory(): boolean {
    return CommonFunctions.hasValue(this.history) || this.historyLoading;
  }
  get hasAssignments(): boolean {
      return CommonFunctions.hasArrayElementValue(this.assignments) || this.assignmentsLoading;
  }
  get hasLabor(): boolean {
    return CommonFunctions.hasValue(this.labor) || this.laborLoading;
  }
  get hasParts(): boolean {
    return CommonFunctions.hasValue(this.parts) || this.partsLoading;
  }
  get hasCustParts(): boolean {
      return CommonFunctions.hasValue(this.custParts) || this.custPartsLoading;
  }
  get hasPartsRequested(): boolean {
    return CommonFunctions.hasValue(this.partsRequested) || this.partsRequestedLoading;
  }
  get hasPartsOrdered(): boolean {
    return CommonFunctions.hasValue(this.partsOrdered) || this.partsOrderedLoading;
  }
  get hasEquipmentSvcd(): boolean {
    return CommonFunctions.hasValue(this.equipment) || this.equipmentLoading;
  }
  get hasStatusHist(): boolean {
    return CommonFunctions.hasValue(this.statusHistory) || this.statusHistoryLoading;
    }
    get hasErrors(): boolean {
        return CommonFunctions.hasValue(this.errors) || this.errorsLoading;
    }
    get hasVendorCredits(): boolean {
        return CommonFunctions.hasValue(this.vendorCredits) || this.vendorCreditsLoading;
    }
    get hasAssets(): boolean {
        return CommonFunctions.hasValue(this.assets) || this.assetsLoading;
    }
    get hasDispatchNotes(): boolean {
        return CommonFunctions.hasValue(this.dispatchNotes) || this.dispatchNotesLoading;
    }
    get hasDispatchKudos(): boolean {
        return CommonFunctions.hasValue(this.dispatchKudos) || this.dispatchKudosLoading;
    }
    get hasLaborQV(): boolean {
        return CommonFunctions.hasValue(this.laborQV) || this.laborQVLoading;
    }

    get hasPartsQV(): boolean {
        return CommonFunctions.hasValue(this.partsQV) || this.partsQVLoading;
    }
    get hasKudosAndOpportunities(): boolean {
        return CommonFunctions.hasValue(this.kudosAndOpportunities) || this.kudosAndOpportunitiesLoading;
    }
    get hasDispatchTrucks(): boolean {
        return CommonFunctions.hasValue(this.dispatchTrucks) || this.dispatchTrucksLoading;
    }

    public getData(id: any, code: string, param: CommonParam = null) : any {
        switch (code.toUpperCase()) {
            case "ALLEQUIP":
                return this.getEquipmentSvcd(id);
            case "SVCDEQUIP":
                return this.getEquipmentSvcdOnly(id);
            case "DISPATCHNOTES":
                return this.getDispatchNotes(id);
            case "ATTACHMENTS":
                return this.getDispatchAttachments(id);
            case "HISTORY":
                if (param !== null) {

                }
                //this.getHistory()
                //return this.getDispatchAttachments(id);
        }
    }
}
